import React from 'react';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { Link, useLocation } from 'react-router-dom';

import ListIcon from 'icons/list.svg';
import GridIcon from 'icons/box-unchecked.svg';
import * as QueryParams from 'components/Explorer/models/query_params';
import useQueryParams from 'hooks/useQueryParams';

const ViewSelector = () => {
  const location = useLocation();
  const params = useQueryParams();

  const trackEvent = (type) => {
    Analytics.trackEvent('research-outputs-change-view', { type });
  };

  const option = (type) => {
    const Icon = type === 'list' ? ListIcon : GridIcon;
    const next = QueryParams.withView(params, type);
    const to = { pathname: location.pathname, search: QueryParams.searchFor(next) };
    return (
      <Link
        data-tooltip-content={I18n.t(type, { scope: 'Explorer.Outputs.view_options' })}
        data-tooltip-id="ViewSelector"
        to={to}
        className={`option ${params.view === type ? 'active' : ''}`}
        onClick={() => trackEvent(type)}
      >
        <Icon />
        <label>{I18n.t(type, { scope: 'Explorer.Outputs.view_options' })}</label>
      </Link>
    );
  };

  return (
    <div className="Explorer-Outputs-ViewSelector">
      <fieldset>
        <ReactTooltip id="ViewSelector" effect="solid" />
        <legend>{I18n.t('Explorer.Outputs.view')}</legend>
        <div className="options">
          {option('grid')}
          {option('list')}
        </div>
      </fieldset>
    </div>
  );
};

export default ViewSelector;
